var host = window.location.href;
var pre = '.submenu ul li:nth-of-type(1) a';
var soft = '.submenu ul li:nth-of-type(2) a';
var standard = '.submenu ul li:nth-of-type(3) a';
var strong = '.submenu ul li:nth-of-type(4) a';
var bulk = '.submenu ul li:nth-of-type(5) a';
var mini = '.submenu ul li:nth-of-type(6) a';

if (host == 'https://shop-bbtape.myshopify.com/pages/tape-premium') {
   $(pre).css({"color":"red","font-weight":"700"});
} else if (host == 'https://shop-bbtape.myshopify.com/pages/soft') {
   $(soft).css({"color":"#f26722","font-weight":"700"});
} else if(host == 'https://shop-bbtape.myshopify.com/pages/standard') {
   $(standard).css({"color":"#f26722","font-weight":"700"});
} else if(host == 'https://shop-bbtape.myshopify.com/pages/strone') {
   $(strong).css({"color":"#f26722","font-weight":"700"});
} else if(host == 'https://shop-bbtape.myshopify.com/pages/bulk') {
   $(bulk).css({"color":"#f26722","font-weight":"700"});
} else if(host == 'https://shop-bbtape.myshopify.com/pages/mini') {
   $(mini).css({"color":"#f26722","font-weight":"700"});
} 